/**
 * @export
 * @returns
 */
export function toggleSelectedUnit(unit) {
    return {
        type: "TOGGLE_SELECTED_UNIT",
        unit
    };
}

export function updateSelectedUnit(unit) {
    return {
        type: "UPDATE_SELECTED_UNIT",
        object: unit
    }
}

export function setUnitsList(units) {
    return {
        type: "SET_UNITS_LIST",
        units
    };
}

/**
 * @export
 * @returns
 */
export function requestUnitsList() {
    return {
        type: "REQUEST_UNITS_LIST",
    };
}


